export type WriterProjectMenuKeyboardEvent = {
  currentTarget: HTMLElement;
  key: string;
  preventDefault: () => void;
  shiftKey: boolean;
  stopPropagation: () => void;
};

type WriterProjectMenuKeyboardOptions = {
  close: () => void;
  event: WriterProjectMenuKeyboardEvent;
  scheduleFocus?: (callback: () => void) => void;
  trigger: HTMLButtonElement | null;
};

const navigationKeys = ["ArrowDown", "ArrowUp", "Home", "End", "Tab"];

export function handleWriterProjectMenuKeyboard({
  close,
  event,
  scheduleFocus = (callback) => requestAnimationFrame(callback),
  trigger,
}: WriterProjectMenuKeyboardOptions) {
  if (event.key === "Escape") {
    event.preventDefault();
    event.stopPropagation();
    close();
    scheduleFocus(() => trigger?.focus());
    return true;
  }
  if (!navigationKeys.includes(event.key)) return false;

  const buttons = Array.from(
    event.currentTarget.querySelectorAll<HTMLButtonElement>("button:not([disabled])"),
  );
  if (!buttons.length) return false;

  const currentIndex = buttons.indexOf(event.currentTarget.ownerDocument.activeElement as HTMLButtonElement);
  const previous = event.key === "ArrowUp" || (event.key === "Tab" && event.shiftKey);
  const nextIndex = event.key === "Home"
    ? 0
    : event.key === "End"
      ? buttons.length - 1
      : (currentIndex + (previous ? -1 : 1) + buttons.length) % buttons.length;
  event.preventDefault();
  buttons[nextIndex]?.focus();
  return true;
}
